//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

//components
import FornecedoresLista from '../childrens/FornecedoresLista/.mixins/FornecedoresLista';

// controllers
import Pessoa_controller from '../../../../../../../../../../controllers/pessoa';
import Log from '../../../../../../../../../../controllers/log';

export default class Fornecedores extends Component {

    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.state = {
            itensTable: [],
            title: 'Fornecedores',
            columns: [
                {
                    name: "Selecionar",
                    options: {
                      filter: false,
                      customBodyRender: (value, tableMeta, updateValue) => (
                        <div align="center">
                            <Checkbox
                                edge="start"
                                value={value.ID_PESSOA}
                                checked={(value.VISIVEL == null || value.VISIVEL == false)?false:true}
                                tabIndex={-1}
                                disableRipple
                                style={{color:'#159B78',margin:0}}
                                onClick={()=>{this.handler(value.ID_PESSOA)}}
                            />
                        </div>
                      )
                    }
                },
                "Nome",
                "E-mail"
            ],
            isLoading: true,
            download: false,
            size: "small",
            tipo: "F",
            markTodosFiltro: true,
            rowsPerPageOptions: [15,25,50],
            rowsPerPage: 15
        }

        //binds
        this.setState = this.setState.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.markAllFornec = this.markAllFornec.bind(this);

        //carregamento de dados nos campos
        this.loadData();
    }

    recolheFornecedores() {
        var array = [];
        this.state.itensTable.forEach(element => {
            if (element[0].VISIVEL == true) {
                array.push({
                    id_pessoa: element[0].ID_PESSOA,
                    id_cfg: 0,
                    email: element[2]
                });
            }
        });
        this.props.pai.setState({
            fornecedores: array
        });
    }

    markAllFornec() {
        var array = this.state.itensTable;
        array.forEach(e => {
            e[0].VISIVEL = (this.state.markTodosFiltro)?false:true;
        });
        this.setState({
            markTodosFiltro: (this.state.markTodosFiltro)?false:true,
            itensTable: array,
            columns: [
                {
                    name: "Selecionar",
                    options: {
                      filter: false,
                      customBodyRender: (value, tableMeta, updateValue) => (
                        <div align="center">
                            <Checkbox
                                edge="start"
                                value={value.ID_PESSOA}
                                checked={(value.VISIVEL == null || value.VISIVEL == false)?false:true}
                                tabIndex={-1}
                                disableRipple
                                style={{color:'#159B78'}}
                                onClick={()=>{this.handler(value.ID_PESSOA)}}
                            />
                        </div>
                      )
                    }
                },
                "Nome",
                "E-mail"
            ],
        });
        this.recolheFornecedores();
    }

    handler(valor) {
        var itens = this.state.itensTable;
        itens.forEach(element => {
            if (element[0].ID_PESSOA == valor) {
                if (element[0].VISIVEL == null || element[0].VISIVEL == false)
                    element[0].VISIVEL = true;
                else
                    element[0].VISIVEL = false;
            }
        });
        this.setState({
            itensTable: itens,
            columns: [
                {
                    name: "Selecionar",
                    options: {
                      filter: false,
                      customBodyRender: (value, tableMeta, updateValue) => (
                        <div align="center">
                            <Checkbox
                                edge="start"
                                value={value.ID_PESSOA}
                                checked={(value.VISIVEL == null || value.VISIVEL == false)?false:true}
                                tabIndex={-1}
                                disableRipple
                                style={{color:'#159B78'}}
                                onClick={()=>{this.handler(value.ID_PESSOA)}}
                            />
                        </div>
                      )
                    }
                },
                "Nome",
                "E-mail"
            ],
        });
        this.recolheFornecedores();
    }

    async loadData() {

        this.setState({isLoading: true});
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            var r_fornecedores = null;
            var j_r_fornecedores = null;
            var filters = {tipo:this.state.tipo};

            if (this.props.pai.props.params.id != null) {
                var id = this.props.pai.props.params.id;
                r_fornecedores = await Pessoa_controller.getFornecedoresByIdF(token,id,filters);
                j_r_fornecedores = JSON.parse(r_fornecedores.body);

                j_r_fornecedores.itens.forEach(element => {
                    element.VISIVEL = eval(element.VISIVEL.toLowerCase())
                });
            } else {
                r_fornecedores = await Pessoa_controller.getFornecedoresF(token,filters);
                j_r_fornecedores = JSON.parse(r_fornecedores.body);
            }

            if (j_r_fornecedores.status) {
                var array = [];
                j_r_fornecedores.itens.forEach(element => {
                    array.push([
                        {
                            ID_PESSOA:element.ID_PESSOA,
                            VISIVEL:(element.VISIVEL == null || element.VISIVEL == false)?false:true
                        },
                        element.NM_PESSOA,
                        element.RET_EMAIL_PESSOA
                    ]);
                });
                this.setState({
                    itensTable:array,
                    isLoading: false
                });
                this.recolheFornecedores();
            } else {
                this.props.pai.child.current.retorno('Erro ao carregar dados!','error');
            }

            //auditoria
            var str = "Efetuada requisição para recuperação de dados de fornecedores! "
            +"Response:( Method: "+r_fornecedores.res.request.method
            +", StatusCode: "+r_fornecedores.res.statusCode
            +", Body: (limited 100chars)"+r_fornecedores.body.substr(0,100)
            +" )";
            Log.info(token,str);
        } catch (error) {
            this.props.pai.child.current.retorno('Erro na recuperação de dados de fornecedores!','error');
            //auditoria
            var str = "Erro na recuperação de dados de fornecedores! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    }

    async handleChange(e) {
        await this.setState({tipo: e.target.value});
        this.loadData();
    }

    render() {
        return (
            <div>
                <Grid container spacing={0}>
                    <Grid item xs={6}>
                        <div style={{
                            display: 'flex',
                            flexFlow: 'row nowrap',
                            padding: '8px 4px',
                            alignItems: 'center',
                            }}>
                            <Typography
                                variant='body1'
                                style={{
                                    marginRight: 4
                                }}
                                >
                                    Tipo Fornecedor:
                            </Typography>
                            <Select
                                value={this.state.tipo}
                                onChange={this.handleChange}
                            >
                                <MenuItem value="F">Todos</MenuItem>
                                <MenuItem value="M">Móveis</MenuItem>
                                <MenuItem value="A">Acessórios</MenuItem>
                            </Select>
                          </div>
                            {/* <RadioGroup aria-label="tipo" name="tipo" value={this.state.tipo} onChange={this.handleChange}>
                                <FormControlLabel value="F" control={<Radio />} label="Todos" />
                                <FormControlLabel value="M" control={<Radio />} label="Moveis" />
                                <FormControlLabel value="A" control={<Radio />} label="Acessórios" />
                            </RadioGroup> */}

                    </Grid>
                    <Grid item xs={6} align={"center"}>
                        <Button variant="contained" color="primary" onClick={this.markAllFornec}>
                            {(this.state.markTodosFiltro)?'Desmarcar':'Marcar'} todos do filtro
                        </Button>
                    </Grid>
                </Grid>
                <FornecedoresLista {...this}/>
            </div>
        );
    }

}